module.exports = __webpack_public_path__ + "static/media/floridaGlass.0457a96d.jpg";